import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import RippleButton from "../../components/common/RippleButton";
import ButtonForAll from "../../components/common/ButtonForAll";
import IconComponent from "../../components/common/IconComponent";
import { FaFilter } from "react-icons/fa";
import { setB2BQuotationFilterDetails, clearB2BQuotationFilterDetails } from "./b2bQuotationSlice";

const B2BQuotationFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const [expand, setExpand] = useState("");
  const { B2BQuotationFilterDetails, loading } = useAppSelector((state) => state.b2bQuotation);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey((prev) => prev + 1);
  }, [B2BQuotationFilterDetails]);

  const handleSubmit = (values: any) => {
    dispatch(setB2BQuotationFilterDetails(values));
    setExpand("");
  };

  const handleClear = () => {
    dispatch(clearB2BQuotationFilterDetails());
    setExpand("");
  };

  return (
    <Form
      key={formKey}
      onSubmit={handleSubmit}
      initialValues={{ ...B2BQuotationFilterDetails }}
      render={(formRenderProps) => (
        <FormElement>
          <ExpansionPanel
            className="inquiry-filter-panel m-0"
            title={
              <div>
                <IconComponent icon={FaFilter} /> Filter Results
              </div>
            }
            expanded={expand === "filter"}
            onAction={(event: ExpansionPanelActionEvent) => {
              setExpand(event.expanded ? "" : "filter");
            }}
          >
            {expand === "filter" && (
              <GridLayout
                style={{ padding: 10, marginRight: 30 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    name="filterQuotationNo"
                    label="Quotation No"
                    placeholder="Quotation No"
                    component={FormTextField}
                    onChange={(e: any) => {
                      let value = e?.target?.value;
                      value = value?.replace(/[^0-9.]/g, "");
                      const parts = value?.split(".");
                      if (parts?.length > 2) {
                        value = parts[0] + "." + parts?.slice(1)?.join("");
                      }
                      formRenderProps.onChange("filterQuotationNo", {
                        value,
                      });
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="filterName"
                    label="Customer Name"
                    placeholder="Customer Name"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="filterMobileNo"
                    label="Mobile No"
                    placeholder="Mobile No"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="filterEmailID"
                    label="Email ID"
                    placeholder="Email ID"
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  colSpan={4}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginTop: 10,
                  }}
                >
                  <RippleButton
                    id="ClearB2BQuotationFilter"
                    type="button"
                    fillMode="outline"
                    themeColor="error"
                    style={{ marginRight: 10 }}
                    onClick={handleClear}
                  >
                    Clear
                  </RippleButton>
                  <ButtonForAll
                    id="B2BQuotationFilterSubmit"
                    label="Filter"
                    type="submit"
                    disabled={loading}
                  />
                </GridLayoutItem>
              </GridLayout>
            )}
          </ExpansionPanel>
        </FormElement>
      )}
    />
  );
};

export default B2BQuotationFilter;
